// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"142":"newslist","164":"terms","309":"newsdetail","957":"privacy"}[chunkId] + "." + {"142":"ea93d2a3","164":"3050034f","309":"6f254bac","957":"0d1902bd"}[chunkId] + ".js";
};